"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JarvisAuthPluginAuthProvider = void 0;
const tslib_1 = require("tslib");
class JarvisAuthPluginAuthProvider {
    constructor() {
        this.accessToken = '';
    }
    getAccessToken(forceRefresh) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.accessToken.length > 0 && !forceRefresh) {
                return this.accessToken;
            }
            if (window.JWeb) {
                try {
                    let options = {
                        accountProviderOptions: {
                            allowNetworkAccess: true,
                            allowUserInteraction: true,
                            showAccountCreationLink: true,
                            skipTokenRefresh: false,
                            requireFreshToken: !!forceRefresh
                        }
                    };
                    let response = yield window.JWeb.Plugins.Auth.getToken(options);
                    if (response !== undefined && response !== null && 'tokenValue' in response) {
                        this.accessToken = response.tokenValue;
                    }
                }
                catch (err) {
                    // Do something!
                }
            }
            return this.accessToken;
        });
    }
}
exports.JarvisAuthPluginAuthProvider = JarvisAuthPluginAuthProvider;
//# sourceMappingURL=jarvis-auth-plugin-auth-provider.js.map